module.exports = __webpack_public_path__ + "public/images/header-slide-3.b080f8034c3e87c49d43094ad7641686.jpeg";